import { Phone, ShieldCheck, Award } from "lucide-react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/393ec47e-fc30-4122-8543-3610be459609/images/d12c45c07b396a1fad2ba5f86ad4123dc669f1068783f355fb72295aef4e83c4.png";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden bg-[#FDFBF7]"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Texas State Capitol"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F]/95 via-[#0A192F]/85 to-[#0A192F]/40" />
        <div className="absolute inset-0 grain" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24 sm:pt-24 sm:pb-32 lg:pt-32 lg:pb-40">
        <div className="max-w-3xl">
          {/* Eyebrow */}
          <div className="anim-fade-in flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-medium">
              Est. Texas · Serving Nationwide
            </span>
          </div>

          {/* Headline */}
          <h1
            data-testid="hero-headline"
            className="anim-fade-up font-serif-display text-[#FDFBF7] text-5xl sm:text-6xl lg:text-7xl font-medium leading-[1.05] tracking-tight"
          >
            Claim what is
            <br />
            <span className="italic text-[#D4AF37]">rightfully</span> yours.
          </h1>

          <p
            className="anim-fade-up mt-8 max-w-xl text-[#E2DCD0] text-lg leading-relaxed font-light"
            style={{ animationDelay: "120ms" }}
          >
            When a property sells for more than what is owed, the surplus
            belongs to <em className="not-italic font-medium text-[#FDFBF7]">you</em>.
            We recover the money the county is holding in your name — quietly,
            ethically, and on contingency.
          </p>

          {/* CTAs */}
          <div
            className="anim-fade-up mt-12 flex flex-wrap items-center gap-4"
            style={{ animationDelay: "240ms" }}
          >
            <a
              href="#claim"
              data-testid="hero-primary-cta"
              className="inline-flex items-center justify-center bg-[#D4AF37] text-[#0A192F] hover:bg-[#FDFBF7] hover:text-[#0A192F] transition-all duration-300 text-base font-semibold px-8 py-4 rounded-sm tracking-wide"
            >
              Start My Free Claim Check
            </a>
            <a
              href="tel:8176802751"
              data-testid="hero-phone-cta"
              className="inline-flex items-center gap-2 text-[#FDFBF7] border border-[#FDFBF7]/30 hover:bg-[#FDFBF7]/10 px-7 py-4 rounded-sm transition-colors"
            >
              <Phone className="h-4 w-4" />
              <span className="font-medium">817-680-2751</span>
            </a>
          </div>

          {/* Trust strip */}
          <div
            className="anim-fade-up mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl"
            style={{ animationDelay: "360ms" }}
          >
            <Stat icon={ShieldCheck} value="$0" label="Upfront Fees, Ever" />
            <Stat icon={Award} value="100%" label="Contingency Based" />
            <Stat icon={ShieldCheck} value="Licensed" label="& Bonded" />
          </div>
        </div>
      </div>

      {/* Bottom hairline */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-[#D4AF37]/30" />
    </section>
  );
};

const Stat = ({ icon: Icon, value, label }) => (
  <div className="flex items-start gap-3 border-l border-[#D4AF37]/40 pl-4">
    <Icon className="h-5 w-5 text-[#D4AF37] mt-1 shrink-0" />
    <div>
      <div className="font-serif-display text-2xl text-[#FDFBF7] leading-none">
        {value}
      </div>
      <div className="text-xs text-[#E2DCD0] uppercase tracking-wider mt-1">
        {label}
      </div>
    </div>
  </div>
);
